import { EventData } from '~/gamification/types/gamification.types'

import ExpandButton from './ExpandButton'
import ChooseAward from './ChooseAward'

export default function CompetitionItem({
  completed = [],
  id,
  onClick,
  className,
}: {
  completed: EventData[]
  id: string
  onClick: () => void
  className: string
}): React.ReactElement {
  const disableClassName = 'opacity-10 grayscale'
  const isUnlocked = completed.find((unlock) => unlock.id === id)
  const unlockedClassName = isUnlocked ? 'hover:cursor-pointer' : disableClassName

  const onItemClick = (): void => {
    if (isUnlocked) onClick()
    else return
  }

  return (
    <div className={`${unlockedClassName} bg-white rounded px-1 py-0.5 mb-auto`} onClick={onItemClick}>
      <div className={className}>
        <div className="max-h-11">
          <ChooseAward type={isUnlocked?.award} />
        </div>
        <ExpandButton disabled={!isUnlocked} />
      </div>
    </div>
  )
}
